/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-copy-file': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.147 9.187L13.36 5.36a1.218 1.218 0 00-.861-.36H7.5c-.69 0-1.25.56-1.25 1.25v11.875c0 .69.56 1.25 1.25 1.25h8.75c.69 0 1.25-.56 1.25-1.25v-8.077c0-.322-.128-.631-.353-.861zM12.5 6.269L16.203 10H12.5V6.269zm-5 11.856V6.25h3.75V10c0 .69.56 1.25 1.25 1.25h3.75v6.875H7.5zM3.75 11.25H2.5V2.5c0-.69.56-1.25 1.25-1.25h8.75V2.5H3.75v8.75z"/>'
  }
})
